<div style="display:contents;" class="tab-viewport">
  <!--  [ngClass]="{'hide':browsersniffer.isPhone}" -->
  <!-- PHONE -->
  <ng-container>
    @if(browsersniffer.isPhone()){
      <div>
        <!-- phone version -->
        <!-- to menu? -->
        <!-- <div class="list-sub-header">
        {{
        isActive()
        ? editingExistingRoute()
        ? ("trace.create-route.subtitle-old" | translate)
        : ("trace.create-route.subtitle-new" | translate)
        : ""
        }}
      </div> -->
      <div class="trace-body column no-footer">
        <div class="trace-data" style="margin-top: -15px;">
          <!-- <div class="mat-title-medium">
          {{ "trace.route_shortinfo" | translate }}
        </div> -->
        <div class="routeinfo">
          <div class="routeData mt-1 mb-1 flex-container">
            <a [matTooltip]="'trace.total-distance' | translate" matTooltipPosition="above"
              [matTooltipShowDelay]="1000" class="route-length phone">
              <mat-icon fontSet="ngi" fontIcon="measure"></mat-icon>
              <span class="" [innerHTML]="ref_formattedRouteLength()"></span>
            </a>
            <!-- <div class="flex-container mt-1"> -->
            <a [matTooltip]="'trace.total-height' | translate" matTooltipPosition="above" [matTooltipShowDelay]="1000"
              class="upward-distance flex-container align-baseline phone">
              <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
              <span [innerHTML]="ref_formattedRouteUpwardDistance()"></span>
            </a>
            <!-- <a [matTooltip]="'trace.downward-height' | translate" matTooltipPosition="above"
            [matTooltipShowDelay]="1000" class="downward-distance flex-container align-baseline">
            <mat-icon fontSet="ngi" fontIcon="elevation-profile-downward"></mat-icon>
            <span [innerHTML]="ref_formattedRouteDownwardDistance()"></span>
          </a> -->
        <!-- </div> -->
      </div>
      <!-- <div class="routeData mb-1 mt-1">
      <a title="{{'trace.total-distance' | translate}}">
        <mat-icon fontSet="ngi" fontIcon="measure"></mat-icon>
        <span class="">{{ref_formattedRouteLength()}}</span>
        &nbsp;&nbsp;
      </a>
      <a title="{{'trace.total-height' | translate}}">
        <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
        &nbsp;<span class="">{{ref_formattedRouteUpwardDistance()}}</span>
      </a>
      <a title="{{'trace.downward-height' | translate}}">
        <mat-icon fontSet="ngi" fontIcon="elevation-profile-downward"></mat-icon>
        &nbsp;<span class="">{{ref_formattedRouteDownwardDistance()}}</span>
      </a>
    </div> -->
  </div>
  <!--  || ref_traceRouteData_metadata().desc  -->
  @if (ref_traceRouteData_metadata().name) {
    <div class="route-title">
      <div class="route-title-wrapper">
        <mat-icon (click)="editGeneralinfo(true);">edit</mat-icon>
        <div class="truncate">{{ref_traceRouteData_metadata().name}}</div>
      </div>
    </div>
  } @else {
    @if (browsersniffer.isPhone()) {
      <div class="route-title">
        <div class="route-title-wrapper">
          <mat-icon (click)="editGeneralinfo(true);">edit</mat-icon>
          <span class="mat-title-small">{{ "trace.view-route.routewithnoname" | translate }}</span>
        </div>
      </div>
    }
    @if (!browsersniffer.isPhone()) {
      <div class="routes create pa-10">
        <span class="mat-title-small">{{ "trace.create-route.no-name-and-desc" | translate }}</span>
        @if (!ref_traceRouteData_metadata().name && !ref_traceRouteData_metadata().desc) {
          <button style="margin:15px 10px"
            color="" mat-stroked-button (click)="editGeneralinfo(true)">{{ "trace.create-route.add-name-and-desc-btn" |
            translate }}
          </button>
        }
      </div>
    }
  }
</div>
</div>
</div>
}
</ng-container>

<!-- DESKTOP -->
<!-- [ngClass]="{'hide':!browsersniffer.isPhone}"-->
<ng-container>
  @if(!browsersniffer.isPhone()){
    <div>
      <div class="trace-header flex-container container-space-between column" tabindex="-1">
        <h4 class="">{{ "trace.create-route.title" | translate }}</h4>
        <div class="list-sub-header">
          {{
          isActive()
          ? editingExistingRoute()
          ? ("trace.create-route.subtitle-old" | translate)
          : ("trace.create-route.subtitle-new" | translate)
          : ""
          }}
        </div>
        <!-- <div class="version" *ngIf="isActive() && ref_traceRouteData_metadata().time > -1"
        [innerHTML]="('trace.version' | translate) + ' &nbsp;' + traceService.getTraceRouteData_metadatatime_string(true, true)">
      </div> -->
    </div>
    <div class="trace-body column no-footer">
        <!-- <button type="button" class="route-profile mat-flat-button mat-primary" [ngClass]="{
        'mat-button-disabled':
          !isActive() ||
          !ref_hasRouteToCreateProfile()
      }" [disabled]="
        !isActive() ||
        !ref_hasRouteToCreateProfile()
      " (click)="traceService.toggleElevationProfile()">
      {{ "trace.route-profile" | translate }}
    </button> -->

    <div class="trace-data">
      <div  class="routes create" style="margin:0px 0px 24px 0px">
        <!-- accent -->
        <button style="margin: 15px 10px" [disabled]="!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap() && !ref_isRouteWithGeneralInfo() && !traceCreateUndoService.canUndoLastChange() && !traceCreateUndoService.canRedoLastChange()" color="primary" mat-stroked-button (click)="startNewDrawing()" [matTooltip]="'trace.route_new_drawing-tip' | translate" matTooltipPosition="above">
          <mat-icon>replay</mat-icon>{{'trace.route_new_drawing' | translate}}
        </button>
      </div>

      <div class="mat-title-medium">
        {{ "trace.route_shortinfo" | translate }}
      </div>

      <div class="routeinfo">
        <div class="routeData mt-1 mb-1 ">
          <a [matTooltip]="'trace.total-distance' | translate" matTooltipPosition="above"
            [matTooltipShowDelay]="1000" class="route-length">
            <mat-icon fontSet="ngi" fontIcon="measure"></mat-icon>
            <span class="" [innerHTML]="ref_formattedRouteLength()"></span>
          </a>
          <div class="flex-container mt-1">
            <a [matTooltip]="'trace.total-height' | translate" matTooltipPosition="above"
              [matTooltipShowDelay]="1000" class="upward-distance flex-container align-baseline">
              <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
              <span [innerHTML]="ref_formattedRouteUpwardDistance()"></span>
            </a>
            <a [matTooltip]="'trace.downward-height' | translate" matTooltipPosition="above"
              [matTooltipShowDelay]="1000" class="downward-distance flex-container align-baseline">
              <mat-icon fontSet="ngi" fontIcon="elevation-profile-downward"></mat-icon>
              <span [innerHTML]="ref_formattedRouteDownwardDistance()"></span>
            </a>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>

      <div class="mat-title-medium mt-2">
        {{ 'trace.create-route.generalinfo-title' | translate }}
      </div>

      @if (ref_traceRouteData_metadata().name || ref_traceRouteData_metadata().desc) {
            <div class="routes create description  mb-1" [ngClass]="{
          'editing': traceService.generalInfoUpForEditing,
          'deleting': traceService.generalInfoUpForDeletion}">
          <strong>{{ref_traceRouteData_metadata().name}}</strong><br>
          <div class="title" [innerHTML]="ref_traceRouteData_metadata().desc"></div>
          @if ( ref_traceRouteData_metadata().name || ref_traceRouteData_metadata().desc) {
            <div class="metadata-utils mt-1" style="text-align: right;"
              >
              <button class="btn-edit" mat-icon-button (click)="editGeneralinfo(true);"
                (mouseover)="traceService.addGeneralInfoHighlight('edit');$event.stopPropagation();"
                (mouseleave)="traceService.removeGeneralInfoHighlight()">
                <mat-icon>edit</mat-icon>
              </button>
              <button class="btn-delete" mat-icon-button (click)="deleteGeneralinfo();"
                (mouseover)="traceService.addGeneralInfoHighlight('delete');$event.stopPropagation();"
                (mouseleave)="traceService.removeGeneralInfoHighlight()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      } @else {
        @if (browsersniffer.isPhone()) {
          <div class="route-title">
            <div class="route-title-wrapper">
              <mat-icon (click)="editGeneralinfo(true);">edit</mat-icon>
              <span class="mat-title-small">{{ "trace.view-route.routewithnoname" | translate }}</span>
            </div>
          </div>
        }
        @if (!browsersniffer.isPhone()) {
          <div class="routes create pa-10">
            <span class="mat-title-small">{{ "trace.create-route.no-name-and-desc" | translate }}</span>
            @if (!ref_traceRouteData_metadata().name && !ref_traceRouteData_metadata().desc) {
              <button style="margin:15px 10px"
                color="" mat-stroked-button (click)="editGeneralinfo(true)">{{ "trace.create-route.add-name-and-desc-btn" |
                translate }}
              </button>
            }
          </div>
        }
      }
      <!-- <mat-divider></mat-divider> -->
      <!-- route info-->
      <!-- route points -->
      <div class="mat-title-medium mt-2">
        {{ "trace.create-route.routepoints" | translate }}
      </div>

      @if (ref_hasRouteOnMap()) {
        @if (ref_hasRouteToCreateProfile()) {
          <div class="routes create">
            <div class="routePoint">
              @if (isActive() || ref_hasRouteOnMap()) {
                <div class="title routeLimit reverse"
                  (click)="traceService.reverseRoute()">
                  <span>&nbsp;</span>
                  {{ "trace.reverse-route" | translate }}
                </div>
              }
            </div>
          </div>
        }
        <div class="routes create">
          <!-- <ng-container *ngFor="let routePoint of ref_traceRouteData_routes()[0].routePoints.;let i = index"> -->
          <!-- we only handle one route at this moment -->
          <!-- <ng-container *ngIf="isActive() && ref_hasRouteOnMap(); else showNgTemplateNoPointsRoute"> -->
          @for (routePoint of ref_traceRouteData_routes()[0].routePoints; track routePoint.drawId; let i = $index) {
            @if (ref_intermediateRoutePointsCount() > 0 && i===1) {
              <div id="intermediateRoutePoints" class="routePoint intermediateRoutePoints truncate">
                <div tabindex="-1" class="title"
                      [ngClass]="{
                  'highlight': !showAllIntermediateRoutePoints() && traceService.highlightedRoutePoint().length > 0 && traceService.highlightedRoutePoint() != '0_0' && traceService.highlightedRoutePoint() != ('0_' + (ref_traceRouteData_routes()[0].routePoints.length - 1))}"
                      (click)="toggleShowAllIntermediateRoutePoints()">
                  {{(showAllIntermediateRoutePoints() ? "trace.create-route.hidepoints" :
                  "trace.create-route.showpoints")
                  |
                  translate }}&nbsp;({{ref_intermediateRoutePointsCount()}})
                </div>
              </div>
            }
            @if (!ref_traceRouteData_routes()[0].routePoints[i].autoDraw && (showAllIntermediateRoutePoints() || i<1 || i===(ref_traceRouteData_routes()[0].routePoints.length -1))) {
              <div [attr.id]="'routePoint_0_' + i" class="routePoint">
                <div tabindex="-1" class="title"
                      [ngClass]="{
                    'highlight': traceService.highlightedRoutePoint() === ('0_' + i),
                    'deleting': traceService.highlightedRoutePointUpForDeletion(),
                    'routeLimit' : i === 0 || i === (ref_traceRouteData_routes()[0].routePoints.length -1),
                    'startPoint' : i === 0,
                    'endPoint' : i>0 && i === (ref_traceRouteData_routes()[0].routePoints.length -1),
                    'clkCENTER': traceService.highlightedRoutePoint() === ('0_' + i) && traceService.clickActionRoutePoint() === 'clkCENTER', 
                    'clkZOOMIN': traceService.highlightedRoutePoint() === ('0_' + i) && traceService.clickActionRoutePoint() === 'clkZOOMIN', 
                    'clkZOOMOUT': traceService.highlightedRoutePoint() === ('0_' + i) && traceService.clickActionRoutePoint() === 'clkZOOMOUT'}"
                  (click)="traceService.zoomToRoutePoint(0,i);$event.stopPropagation()"
                  (mouseover)="traceService.addRoutePointHighlight(0,i,false)"
                  (mouseleave)="traceService.removeRoutePointHighlight()">
                  <span>&nbsp;</span>
                  {{traceService.clickActionRoutePoint()}}
                  <span class="formattedXY" [innerHTML]="routePoint.formattedXY"></span>
                  @if ( i===0) {
                    <span
                      class="hidden-for-md">&nbsp;|&nbsp;{{"trace.create-route.routepoint-start" |
                    translate}}</span>
                  }
                  @if (i>0 && i === (ref_traceRouteData_routes()[0].routePoints.length -1)) {
                    <span class="hidden-for-md">&nbsp;|&nbsp;{{"trace.create-route.routepoint-end" |
                    translate}}</span>
                  }
                  <button mat-icon-button aria-label="delete point of route"
                    (click)="deleteRoutePoint(0, i, false);$event.stopPropagation()"
                    (mouseover)="traceService.addRoutePointHighlight(0,i,'delete');$event.stopPropagation()"
                    (mouseleave)="traceService.removeRoutePointHighlight()">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            }
          }
          <!-- toggle profile-->
          <!--
          <div *ngIf="isActive() || ref_hasRouteToCreateProfile()" class="routePoint" id=""
            (click)="traceService.toggleElevationProfile()">
            <div class="title routeLimit elevation">
              <mat-icon>landscape</mat-icon>
              {{ "trace.route-profile" | translate }}
            </div>
          </div>
          -->
        </div>
        <!-- <mat-divider></mat-divider> -->
      } @else {
        <div class="routes create pa-10">
          {{ "trace.no-route_1" | translate }}
          (<span style="font-size: 15px;line-height: 11px;"><mat-icon inline="true">polyline</mat-icon></span>)
          {{ "trace.no-route_2" | translate }}
        </div>
      }

      <!-- <br> -->
      <div class="mat-title-medium">{{ "trace.pois" | translate }}</div>
      @if (isActive() && ref_hasWayPointsOnMap()) {
            <!-- <ng-container *ngIf="isActive() && ref_hasWayPointsOnMap(); > -->
            <!-- waypoints -->
            <div class="wayPoints create">
              @for (
              wayPoint of ref_traceRouteData_waypoints(); track 
              wayPoint.drawId; let i = $index) {

                <div [attr.id]="'wayPoint_' + i" tabindex="-1" class="wayPoint" [ngClass]="
                  {'highlight': traceService.highlightedWayPoint() === i,
                   'editing': 'edit' === traceService.highlightedWayPointUpForEditing(),
                  'deleting': 'delete' ===  traceService.highlightedWayPointUpForEditing() }
                " (click)="traceService.zoomToWayPoint(i,$event)"
              (mouseover)="traceService.addWayPointHighlight(i, false)"
              (mouseleave)="traceService.removeWayPointHighlight()">
              <div class="title"
                [innerHTML]="'<div class=\'index-container\'><span>' + (i + 1) + ' </span></div>' + wayPoint.formattedName"
                    [ngClass]="{ 
                    'clkCENTER': traceService.highlightedWayPoint() === i && traceService.clickActionWayPoint() === 'clkCENTER', 
                    'clkZOOMIN': traceService.highlightedWayPoint() === i && traceService.clickActionWayPoint() === 'clkZOOMIN', 
                    'clkZOOMOUT': traceService.highlightedWayPoint() === i && traceService.clickActionWayPoint() === 'clkZOOMOUT' }">
              </div>
              <div class="description"
                [innerHTML]="wayPoint.formattedDesc">
              </div>
              <div class="coord" [innerHtml]="wayPoint.formattedXY"></div>
              <div class="wayPoint-utils">
                <button class="btn-edit" mat-icon-button aria-label="edit poi"
                  (click)="editWayPoint(false, i);$event.stopPropagation();"
                  (mouseover)="traceService.addWayPointHighlight(i, 'edit');$event.stopPropagation();"
                  (mouseleave)="traceService.removeWayPointHighlight()">
                  <mat-icon>edit</mat-icon>
                </button>
                <button class="btn-delete" mat-icon-button aria-label="delete poi"
                  (click)="deleteWayPoint(i);$event.stopPropagation();"
                  (mouseover)="traceService.addWayPointHighlight(i, 'delete');$event.stopPropagation();"
                  (mouseleave)="traceService.removeWayPointHighlight()">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          }
        </div>
        <!-- <mat-divider></mat-divider> -->
      } @else {
        <div class="routes create pa-10">
          {{ "trace.no-points_1" | translate }}
          (<span style="font-size: 15px;line-height: 11px;"><mat-icon inline="true">location_on</mat-icon></span>)
          {{ "trace.no-points_2" | translate }}
          <!-- &nbsp; {{ "trace.create-route.pois-auto-order" | translate }} -->
        </div>
      }
    </div>
  </div>
</div>
}
</ng-container>
</div>




